import { render, staticRenderFns } from "./main.vue?vue&type=template&id=76e5eb56&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./main.vue?vue&type=style&index=0&id=76e5eb56&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e5eb56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76e5eb56')) {
      api.createRecord('76e5eb56', component.options)
    } else {
      api.reload('76e5eb56', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=76e5eb56&scoped=true", function () {
      api.rerender('76e5eb56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/manager-form/email/components/domain/main.vue"
export default component.exports